import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';
const dpRoot = 'Other Achievements';

const sharedProps = {
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	portal: 'CP' as LocPortal,
};

export type CPOtherAchievementsLocs =
	| 'CPOtherAchievementsName'
	| 'CPOtherAchievementsPageTitle'
	| 'CPOtherAchievementsVendor'
	| 'CPOtherAchievementsDateAchieved'
	| 'CPOtherAchievementsCertId'
	| 'CPOtherAchievementsExpireDate'
	| 'CPOtherAchievementsStatus'
	| 'CPOtherAchievementsAdd'
	| 'CPOtherAchievementsEdit';

export const cpOtherAchievementLocs: LocDefs<CPOtherAchievementsLocs> = {
	CPOtherAchievementsPageTitle: {
		defaultValue: 'Industry Certifications',
		description: 'Title for Industry Certifications page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		...sharedProps,
	},
	CPOtherAchievementsName: {
		defaultValue: 'Industry Certification Name',
		description: 'Label for industry certification name.',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsVendor: {
		defaultValue: 'Vendor',
		description: 'Label for group.',
		displayPath: `${dpRoot}|Vendor`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsStatus: {
		defaultValue: 'Status',
		description: 'Label for status.',
		displayPath: `${dpRoot}|Status`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsDateAchieved: {
		defaultValue: 'Date Achieved',
		description: 'Label for Date achieved.',
		displayPath: `${dpRoot}|Date Achieved`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsExpireDate: {
		defaultValue: 'Expiration Date',
		description: 'Label for Expiration Date.',
		displayPath: `${dpRoot}|Expiration Date`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsCertId: {
		defaultValue: 'Certification ID',
		description: 'Label for Certification ID.',
		displayPath: `${dpRoot}|Certification ID`,
		displayType: 'Label',
		...sharedProps,
	},
	CPOtherAchievementsAdd: {
		defaultValue: 'Add Certification',
		description: 'Label for Add button.',
		displayPath: `${dpRoot}|Add Button`,
		displayType: 'Button',
		...sharedProps,
	},
	CPOtherAchievementsEdit: {
		defaultValue: 'Edit',
		description: 'Label for Add button.',
		displayPath: `${dpRoot}|Edit Button`,
		displayType: 'Button',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPOtherAchievementsLocs>(cpOtherAchievementLocs);
export type CpOtherAchievementsLocType = LocMap<CPOtherAchievementsLocs>;
